import React from "react";
import {PageHero} from "../common/PageHero";

const fees = [
    {label: 'Senioren', price: '80€', detail: 'Competitie op maandag & dinsdagavond'},
    {label: 'Jeugd', price: '40€', detail: 'Competitie op zaterdagvoormiddag'},
    {label: 'Recreant', price: '50€', detail: 'Recreanten kunnen invallen bij de competitiespelers, meld dit even bij het inschrijven'},
    {label: 'Gereduceerd tarief', price: '− 18€', detail: 'Korting bij erkend kansentarief van de Stad Antwerpen'}
];

export const NewMembers = () => {
    return (
        <>
            <PageHero title={'Info voor nieuwe leden'}
                      badge={'Welkom'}
                      lead={'Tafeltennis is een sport voor zowel jong als oud — kom drie keer vrijblijvend proeven.'}/>
            <div className={'ttc-section ttc-split'}>
                <article className={'ttc-card'}>
                    <p className={'ttc-eyebrow'}>Voor wie?</p>
                    <p className={'ttc-card-body'}>Iedereen! Tafeltennis is een sport voor zowel jong als oud. Wij
                        hebben leden die beginnen op hun 12, terwijl anderen er pas na hun pensioen mee beginnen!
                        Iedereen heeft steeds de mogelijkheid om, vooraleer het lidgeld te betalen, drie keer te komen
                        proeven op een speelavond. Aansluiten kan het ganse seizoen, na nieuwjaar gelden gereduceerde
                        lidgeldtarieven.</p>
                </article>
                <article className={'ttc-card'}>
                    <p className={'ttc-eyebrow'}>Praktische info</p>
                    <p className={'ttc-card-body'}>Beginnende spelers kunnen een paletje van de club gebruiken. Bij
                        aansluiting als competitie- of jeugdlid voorzien we één gratis truitje. Voorzie ook propere
                        sportschoenen, d.w.z. schoenen die niet gebruikt zijn om buiten te sporten. Buiten het
                        competitieseizoen kunnen al onze leden op dinsdagavond vrij komen spelen. Daarnaast spelen we
                        het hele jaar door op donderdagmiddag vanaf 13u30.</p>
                </article>
            </div>

            <h2 className={'ttc-section-title mt-4 mb-3'}>Lidgeld</h2>
            <div className={'ttc-card-grid'}>
                {fees.map((fee) => (
                    <div className={'ttc-card'} key={fee.label}>
                        <p className={'ttc-eyebrow'}>{fee.label}</p>
                        <p className={'ttc-price'}>{fee.price}</p>
                        <p className={'ttc-card-meta'}>{fee.detail}</p>
                    </div>
                ))}
            </div>

            <article className={'ttc-card featured mt-4'}>
                <p className={'ttc-eyebrow'}>Buiten competitieseizoen</p>
                <p className={'ttc-card-body'}>Vrij spelen op dinsdagavond en donderdagnamiddag.</p>
                <div className={'ttc-btn-row'}>
                    <a className={'ttc-btn'} href={'/documents'}>Aansluitingsformulier</a>
                    <a className={'ttc-btn ghost'} href={'/contact'}>Stel een vraag</a>
                </div>
            </article>
        </>
    )
}
